// extracted by mini-css-extract-plugin
export default {"root":"DYomP0ic2B","table":"nE1Ovn_4zA"};